export const OAUTH_SERVER = process.env.REACT_APP_OAUTH_SERVER;
export const RESPONSE_TYPE = "code";
export const CLIENT_ID = process.env.REACT_APP_CLIENT_ID
  ? process.env.REACT_APP_CLIENT_ID
  : "passcode-manager@service.meetyoo.de";
export const CLIENT_SECRET = process.env.REACT_APP_CLIENT_SECRET;
export const REDIRECT_URL = process.env.REACT_APP_REDIRECT_URL;
export const REFRESH_TOKEN = "refresh_token";
export const GRANT_TYPE = "authorization_code";
export const SCOPE = process.env.REACT_APP_SCOPE;
export const AUTHORIZATION_URL = `${OAUTH_SERVER}/auth?response_type=${RESPONSE_TYPE}&scope=${SCOPE}&client_id=${CLIENT_ID}&redirect_uri=${REDIRECT_URL}`;

export const PASSCODE_SERVER = process.env.REACT_APP_PASSCODE_SERVER;
export const BILLING_SERVER = process.env.REACT_APP_BILLING_SERVER;
export const EVENTMGT_SERVER = process.env.REACT_APP_EVENTMGT_SERVER;
export const EVENTMGT_WEBSOCKET = process.env.REACT_APP_EVENTMGT_WEBSOCKET;
export const EVENTMGT_ORDER_SERVER = process.env.REACT_APP_EVENTMGT_ORDER_SERVER;
export const EVENTMGT_REFRESH_TIME = process.env.REACT_APP_EVENTMGT_REFRESH_TIME
  ? process.env.REACT_APP_EVENTMGT_REFRESH_TIME
  : 10000;

export const NAV_COMPANYS = [{key: "meetyoo_conferencing_GmbH", text: "meetyoo conferencing GmbH"}, {key: "MEETYOO_Inc", text: "MEETYOO Inc."}];
